// helpers
import { formatCurrency } from "../../../helpers/formatCurrency";

// utils
import { SheetFactory } from "./SheetFactory";

class GenerateReports {
  static async disagreementsUsedVoucher(
    analyticReport,
    usedVouchers
  ) {
    const disagreements = [];

    const analyticUsedVoucher = analyticReport.filter(
      ({ operation }) => operation === "Utilização"
    );

    const disagreementsInAnalyticReport = analyticUsedVoucher.filter((row) => {
      const existsOtherSide = usedVouchers.filter(
        (voucher) => row.voucher_id === voucher.voucher_id
      );

      const sumValues = existsOtherSide.reduce((acc, curr) => {
        return acc + curr.value;
      }, 0);

      return !existsOtherSide.length || sumValues !== row.value;
    });

    const disagreementsInUsedVoucherReport = usedVouchers.filter((row) => {
      const existsOtherSide = analyticUsedVoucher.filter(
        ({ voucher_id }) => row.voucher_id === voucher_id
      );

      return existsOtherSide.length !== 1;
    });

    disagreementsInAnalyticReport.forEach(({ voucher_id, value }) => {
      disagreements.push({
        voucher_id,
        value,
      });
    });

    disagreementsInUsedVoucherReport.forEach(({ voucher_id, value }) => {
      const exists = disagreements.find(
        (element) => element.voucher_id === voucher_id
      );

      const canBeAdded = disagreementsInUsedVoucherReport.filter(
        (voucher) => {
          const isSameVoucher = voucher.voucher_id === voucher_id;

          if (isSameVoucher) {
            const newValue = value + voucher.value;

            return newValue === 0;
          }

          return false;
        }
      ).length === 0;

      if (!exists && canBeAdded) {
        disagreements.push({
          voucher_id,
          value,
        });
      }
    });

    const sheet = new SheetFactory();

    sheet.setColumnSizes([90, 30]);

    sheet.addTitleRow([
      "Inconsistências Motor Fidelidade x CAR - Contábil (vouchers utilizados)",
    ]);

    sheet.addSubtitleRow(["Voucher ID", "Valor"]);

    const disagreementsRows = disagreements.map(({ voucher_id, value }) => [
      voucher_id,
      formatCurrency(value),
    ]);

    sheet.addRows(disagreementsRows);

    const buffer = await sheet.finishSheet();

    return new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
  }

  static async disagreementsActivatedVoucher(
    analyticReport,
    activatedVouchers
  ) {
    const disagreements = [];

    const analyticActivatedVoucher = analyticReport.filter(
      ({ operation }) => operation === "Ativação"
    );

    const disagreementsInAnalyticReport = analyticActivatedVoucher.filter(
      (row) => {
        const existsOtherSide = activatedVouchers.filter(
          ({ voucher_id, value }) =>
            row.voucher_id === voucher_id && row.value === value
        );

        return existsOtherSide.length !== 1;
      }
    );

    const disagreementsInActivatedVoucherReport = activatedVouchers.filter(
      (row) => {
        const existsOtherSide = analyticActivatedVoucher.filter(
          ({ voucher_id, value }) =>
            row.voucher_id === voucher_id && row.value === value
        );

        return existsOtherSide.length !== 1;
      }
    );

    disagreementsInAnalyticReport.forEach(({ voucher_id, value }) => {
      disagreements.push({
        voucher_id,
        value,
      });
    });

    disagreementsInActivatedVoucherReport.forEach(({ voucher_id, value }) => {
      const exists = disagreements.find(
        (element) => element.voucher_id === voucher_id
      );

      if (!exists) {
        disagreements.push({
          voucher_id,
          value,
        });
      }
    });

    const sheet = new SheetFactory();

    sheet.setColumnSizes([90, 30]);

    sheet.addTitleRow([
      "Inconsistências Motor Fidelidade x CAR - Contábil (vouchers ativados)",
    ]);

    sheet.addSubtitleRow(["Voucher ID", "Valor"]);

    const disagreementsRows = disagreements.map(({ voucher_id, value }) => [
      voucher_id,
      formatCurrency(value),
    ]);

    sheet.addRows(disagreementsRows);

    const buffer = await sheet.finishSheet();

    return new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
  }
}

export { GenerateReports };
